export default "__VITE_ASSET__DRSM7PPO__"